// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1TmvP","description":"PatientConsentPreview_description__1AE3W"};